/** Hidden field name — looks like a normal optional input to bots. */
export const SIGNUP_HONEYPOT_FIELD = 'companyWebsite';

export function isSignupHoneypotFilled(value: string | undefined | null): boolean {
  return Boolean(value?.trim());
}
